import { useContext } from 'react';
import UFOInteractionContext, {
	type UFOInteractionContextType,
} from '@atlaskit/react-ufo/interaction-context';
import { WaitContext } from '@atlassian/react-loosely-lazy';
import useLayoutEffectSAFE from '@jira/platform__app-framework-use-layout-effect-safe';

export const useUFOInteractionContext = (): UFOInteractionContextType | null =>
	useContext(UFOInteractionContext);
const returnTrue = () => true;
export const useHold = (
	name: string | undefined,
	lock: boolean,
	isEnabled: () => boolean = returnTrue,
): void => {
	const interactionContext = useUFOInteractionContext();
	const waitContext = useContext(WaitContext);

	// Runs synchronously, to allow us to identify async items
	useLayoutEffectSAFE(() => {
		if (!lock || !isEnabled()) {
			return;
		}
		// if until context exists means there is a LazyWait parent component
		// we use that value
		const shouldHold = waitContext ? !!waitContext.currentValue() : true;
		if (interactionContext != null && shouldHold) {
			return interactionContext.hold(name);
		}
	}, [interactionContext, name, waitContext, lock, isEnabled]);
};
